import { clsx } from "clsx";

import { Container } from "~/components/container";
import { FadeIn } from "~/components/fade-in";

export function PageIntro({
  eyebrow,
  title,
  children,
  centered = false,
}: {
  eyebrow: string;
  title: string;
  children: React.ReactNode;
  centered?: boolean;
}) {
  return (
    <Container
      className={clsx("mt-16 sm:mt-24 lg:mt-28", centered && "text-center")}
    >
      <FadeIn>
        <h1>
          <span className="label block text-accent-400">{eyebrow}</span>
          <span className="sr-only"> - </span>
          <span
            className={clsx(
              "mt-6 block max-w-4xl font-display text-5xl font-medium tracking-tight text-ink-50 [text-wrap:balance] sm:text-6xl",
              centered && "mx-auto",
            )}
          >
            {title}
          </span>
        </h1>
        <div
          className={clsx(
            "mt-6 max-w-2xl text-lg text-ink-300",
            centered && "mx-auto",
          )}
        >
          {children}
        </div>
      </FadeIn>
    </Container>
  );
}
